import { Lightbulb, AlertTriangle } from "lucide-react";

const KINDS = {
  retain: {
    label: "À retenir",
    Icon: Lightbulb,
    cls: "border-[#2BB08A] bg-[#E8F8F3] text-[#064E3B]",
    testid: "callout-retain",
  },
  warn: {
    label: "Attention",
    Icon: AlertTriangle,
    cls: "border-[#E8A317] bg-[#FEF3C7] text-[#78350F]",
    testid: "callout-warn",
  },
};

export default function Callout({ kind = "retain", title, children }) {
  const { label, Icon, cls, testid } = KINDS[kind] || KINDS.retain;
  return (
    <aside
      data-testid={testid}
      className={`my-6 rounded-lg border-l-4 p-5 ${cls}`}
      role="note"
    >
      <p className="mb-1.5 flex items-center gap-2 font-display text-sm font-semibold uppercase tracking-wider">
        <Icon className="h-4 w-4" aria-hidden="true" />
        {title || label}
      </p>
      <div className="text-[0.95rem] leading-relaxed">{children}</div>
    </aside>
  );
}
